import './DataTableV2SelectionChip.css';
export var chipCSS = '_1c5vf9g4-2-0-1';
export var chipWrapperCSS = {condensed:'_1c5vf9g1-2-0-1 _1c5vf9g0-2-0-1','default':'_1c5vf9g0-2-0-1',comfortable:'_1c5vf9g3-2-0-1 _1c5vf9g0-2-0-1'};